const moment = require('moment');
const { default: AggConstants } = require('../../constants/AggConstants');
const { default: TipoAtributo } = require('../../constants/TipoAtributo');
const { SPLIT_CHAR_SPECIAL } = require('../../constants/Split');
const { default: SystemConstants } = require('../../common/SystemConstants');
const FiltroConstants = require('../../constants/FiltroConstants').default;
const Atributos = require('../../common/Atributos');
module.exports = {
    cubo: 'cubo_fichas',
    title: SystemConstants.Strings.paginas.dadosExposicaoVitimaHumana,
    primeiraConsultaAutomatica: true,
    atributosSelecionados: [
        Atributos.F_PACIENTE_SEXO,
        Atributos.F_PACIENTE_FAIXA_ETARIA,
        Atributos.F_PACIENTE_FAIXA_ETARIA_ORD,
        // Atributos.QNT, // Sempre colocar o último atributo como métrica.
    ],
    nextPage: SystemConstants.SiteMapInterno.DADOS_EXPOSICAO_VITIMA_HUMANA_EXPOSICAO,
    backPage: SystemConstants.SiteMapInterno.DADOS_GERAIS_ATENDIMENTO,
    charts: [
        {
            title: 'SEXO DO PACIENTE',
            type: 'ApexPieChart',
            w: 1,
            selectDimensions: [Atributos.F_PACIENTE_SEXO, Atributos.QNT],
            groupByOp: 'sum',
            filters: [
            // {
            //     attribute: Atributos.F_PACIENTE_SEXO,
            //     filter: (value) => value !== 'Não se aplica' && value !== 'Não preenchido' && value !== 'Ignorado',
            // },
            ],
            transformations: [
                {
                    attributes: [Atributos.F_PACIENTE_SEXO],
                    transformation: (value) => {
                        if (value === 'Não se aplica')
                            return 'Ignorado';
                        if (value === 'Não preenchido')
                            return 'Ignorado';
                        return value;
                    },
                },
            ],
            uiConfig: {
                enableAnimation: true,
                // totalDisplayState: 'total', // 'total' | 'parts'
                // orderDirection: 'asc', // 'asc' | 'desc'
                // orderType: 'count', // 'name' | 'count'
                customLabelsArray: ['Masculino', 'Feminino', 'Ignorado'],
                // chartLegendColors: {
                //     Masculino: '#00f',
                //     Feminino: '#f00',
                //     Ignorado: '#ccc',
                // },
                colorLabel: (labels) => {
                    return labels.map((l) => {
                        switch (l) {
                            case 'Masculino':
                                return '#2e93fa';
                            case 'Feminino':
                                return '#94ff65';
                            case 'Ignorado':
                                return '#859ca8';
                            default:
                                return '#000';
                        }
                    });
                },
                // customLabelsArray: ['<1', '1-4', '5-9', '10-14', '15-19', '20-29', '30-39', '40-49', '50-59', '60-69', '70-79', '>=80'],
            },
            // Traz um gráfico em colunas mostrando a situação dos exames de dermatologia por ano. Uma barra contém a contagem de exames "sem laudo" e a outra barra traz a contagem de exames "com laudo".
            // Este card pode ter seus dados filtrados pela variável "Data do exame" presente no dashboard.
        },
        {
            title: 'FAIXA ETÁRIA DO PACIENTE',
            description: 'Faixa etária do paciente.',
            type: 'Pivottable',
            h: '450px',
            headers: ['Paciente: Faixa etária ordenação', 'Paciente: Faixa etária', 'Quantidade'],
            selectDimensions: [Atributos.F_PACIENTE_FAIXA_ETARIA_ORD, Atributos.F_PACIENTE_FAIXA_ETARIA, Atributos.QNT],
            rows: ['Paciente: Faixa etária'],
            rowOrder: 'key_a_to_z',
            aggregatorName: 'Sum as Fraction of Total',
            vals: ['Quantidade'],
            aggregatorList: [
                {
                    vals: ['Quantidade'],
                    aggTitle: 'Quantidade',
                    aggregatorName: 'Integer Sum',
                },
                {
                    vals: ['Quantidade'],
                    aggTitle: '%',
                    aggregatorName: 'Sum as Fraction of Total',
                },
            ],
            cols: [],
            filters: [],
            transformations: [
                {
                    attributes: [Atributos.F_PACIENTE_FAIXA_ETARIA],
                    transformation: (value) => {
                        switch (value) {
                            case 'Não se aplica':
                                return 'Ignorado';
                            case 'Não preenchido':
                                return 'Ignorado';
                            case '<1':
                                return '&#8203;<1';
                            default:
                                return value;
                        }
                    },
                },
            ],
        },
        {
            title: 'SEXO E FAIXA ETÁRIA DO PACIENTE',
            // type: 'ApexBarChart',
            type: 'ApexBarNegativeChart',
            w: 1,
            selectDimensions: [Atributos.F_PACIENTE_SEXO, Atributos.F_PACIENTE_FAIXA_ETARIA, Atributos.QNT],
            filters: [
                {
                    attribute: Atributos.F_PACIENTE_SEXO,
                    filter: (value) => value !== 'Outro' && value !== 'Não se aplica' && value !== 'Não preenchido' && value !== 'Ignorado',
                },
                {
                    attribute: Atributos.F_PACIENTE_FAIXA_ETARIA,
                    filter: (value) => value !== 'Outro' && value !== 'Não se aplica' && value !== 'Não preenchido' && value !== 'Ignorado',
                },
            ],
            transformations: [],
            uiConfig: {
                enableAnimation: true,
                chartLegendColors: {
                    Masculino: '#2e93fa',
                    Feminino: '#94ff65',
                },
                customLabelsArray: ['<1', '1-4', '5-9', '10-14', '15-19', '20-29', '30-39', '40-49', '50-59', '60-69', '70-79', '>=80'],
            },
        },
        {
            title: 'SEXO DO PACIENTE POR FAIXA ETÁRIA',
            type: 'ApexColumnChart',
            w: 1,
            selectDimensions: [Atributos.F_PACIENTE_SEXO, Atributos.F_PACIENTE_FAIXA_ETARIA, Atributos.QNT],
            filters: [
                {
                    attribute: Atributos.F_PACIENTE_SEXO,
                    filter: (value) => value !== 'Não se aplica' && value !== 'Não preenchido' && value !== 'Ignorado',
                },
                {
                    attribute: Atributos.F_PACIENTE_FAIXA_ETARIA,
                    filter: (value) => value !== 'Não se aplica' && value !== 'Não preenchido' && value !== 'Ignorado',
                },
            ],
            transformations: [],
            uiConfig: {
                enableAnimation: true,
                // totalDisplayState: 'total', // 'total' | 'parts'
                // orderDirection: 'asc', // 'asc' | 'desc'
                // orderType: 'count', // 'name' | 'count'
                chartLegendColors: {
                    Masculino: '#2e93fa',
                    Feminino: '#94ff65',
                },
                customLabelsArray: ['<1', '1-4', '5-9', '10-14', '15-19', '20-29', '30-39', '40-49', '50-59', '60-69', '70-79', '>=80'],
            },
            // Traz um gráfico em colunas mostrando a situação dos exames de dermatologia por ano. Uma barra contém a contagem de exames "sem laudo" e a outra barra traz a contagem de exames "com laudo".
            // Este card pode ter seus dados filtrados pela variável "Data do exame" presente no dashboard.
        },
    ],
    metaAtributos: [
        {
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            grupo: 'Nome do centro',
            rotulo: 'Nome do centro',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            grupo: 'Ano de atendimento',
            rotulo: 'Ano de atendimento',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            grupo: 'Tipo de Ficha',
            rotulo: 'Tipo de Ficha',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            grupo: 'UF Solicitante',
            rotulo: 'UF Solicitante',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.GRUPO,
            grupo: 'Grupo de agentes',
            rotulo: 'Grupo de agentes',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_PACIENTE_SEXO,
            grupo: 'Paciente: Sexo',
            rotulo: 'Paciente: Sexo',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_PACIENTE_FAIXA_ETARIA,
            grupo: 'Paciente: Faixa etária',
            rotulo: 'Paciente: Faixa etária',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO,
            grupo: 'Exposição: Circunstância',
            rotulo: 'Exposição: Circunstância',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.F_ENCERRAMENTO_CLASS_GRAVI_DESCRICAO,
            grupo: 'Classificação de Gravidade Final',
            rotulo: 'Classificação de Gravidade Final',
            tipo: 'TEXTO',
        },
        {
            atributo: Atributos.CIRCUNSTANCIA_DESCRICAO,
            grupo: 'Desfecho',
            rotulo: 'Desfecho',
            tipo: 'TEXTO',
        },
    ],
    preFiltrosServer: [
        {
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            tipoComponente: 'IN_SELECT',
            valor: ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026'].join(FiltroConstants.SPLIT_VALUES),
        },
    ],
    filtros: [
        {
            key: 0,
            disabled: true,
            hidden: true,
            atributo: Atributos.F_CABECALHO_TIPO_FICHA,
            rotulo: 'Tipo de ficha',
            tipoComponente: 'IN_SELECT',
            valor: 'Humana',
        },
        {
            key: 1,
            size: 2,
            disabled: true,
            atributo: Atributos.F_ATENDIMENTO_DATA_ANO,
            rotulo: 'Ano do atendimento',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 2,
            size: 2,
            disabled: false,
            atributo: Atributos.GRUPO,
            rotulo: 'Grupo de agentes',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 3,
            size: 2,
            disabled: false,
            atributo: Atributos.F_PACIENTE_SEXO,
            rotulo: 'Sexo',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 4,
            size: 2,
            disabled: false,
            atributo: Atributos.F_PACIENTE_FAIXA_ETARIA,
            rotulo: 'Faixa etária',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 5,
            size: 2,
            disabled: true,
            atributo: Atributos.F_SOLICITANTE_ESTADO_SIGLA,
            rotulo: 'UF Solicitante',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 6,
            size: 2,
            disabled: false,
            atributo: Atributos.F_CABECALHO_NOME_CENTRO,
            rotulo: 'Nome do centro',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 7,
            size: 2,
            disabled: false,
            atributo: Atributos.CIRCUNSTANCIA_DESCRICAO,
            rotulo: 'Circunstância',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
        {
            key: 8,
            size: 2,
            disabled: false,
            atributo: Atributos.F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO,
            rotulo: 'Desfecho',
            tipoComponente: 'IN_SELECT',
            valor: '',
        },
    ],
};
